<template>
  <div>
    <PublicNav></PublicNav>
    <div
      class="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
    >
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import PublicNav from "../components/ui/nav/PublicNav";

export default {
  name: "Public",
  components: {
    PublicNav,
  },
};
</script>
